<template lang="pug">
    .footer(ref='footer')
      .container-fluid.pt-3
        .row
          .col-md-2.center-xy
            img.icon(src="@/assets/images/branding/logo_dark.svg", alt="Wall collective logo")
          .col-6.col-md-4.pt-3.text-left
            ul.p-0.text-dark.py-3(style="list-style-type:none")
              li.link.d-block.d-md-inline
                router-link(:to="{name:'gallery'}") ART
              li.link.d-block.d-md-inline
                router-link(:to="{name:'artists'}") ARTISTS
              li.link.d-block.d-md-inline
                router-link(:to="{name:'rentals'}") RENTALS
              li.link.d-block.d-md-inline
                router-link(:to="{ name: 'HelpPackaging' }") PACKAGING
          .col-6.col-md-4.pt-3.text-left
            ul.p-0.text-dark.py-3(style="list-style-type:none")
              li.link.d-block.d-md-inline-block
                router-link(:to="{name:'about'}") ABOUT US
              li.link.d-block.d-md-inline-block
                router-link(:to="{name:'contact'}") CONTACT
              li.link.d-block.d-md-inline-block
                router-link(:to="{name:'help'}") FAQ
              li.link.d-block.d-md-inline-block
                router-link(:to="{name:'legal'}") LEGAL
          .col-md-2.pt-3
            ul.p-0.text-dark.py-3(style="list-style-type:none")
              li.link
                a.m-2(href="https://www.instagram.com/wall_collective/")
                  i.fab.fa-instagram
                  span.ml-1 @wall_collective
</template>

<script>

export default {
  name: 'FooterSection',
  components: {
  },
};
</script>

<style lang="scss" scoped>

  .footer{
    position: relative;
    padding: 20px 0 20px 0 !important;
    ul {
      li {
        display: inline-block;
        margin: 0 1rem 0 1rem;
      @include phone {
        padding: 1.5rem 0;
      }
      }
    }
    .icon{
      width: 70%;
      max-width: 100px;
    }
    @include phone {
      text-align: center;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/structure/FooterStandard.vue